export default {"src":"/_next/static/media/link.bdd944c9.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};